const DOC_OWNER = "docOwner";
const EXTERNAL_USER = "externalUser";
const ACCOUNT_OWNER = "Admin";
const EMPTY_SHEET_MSG = {
  "Not owned by me":
    "We couldn’t find any Google Sheets <b>owned by you</b> in your Drive. Please check other folders or create a new sheet.",
  "Owned by me":
    "Uh oh! Looks like there are no sheets marked ‘<b>Not owned by me</b>‘ in your Google Drive",
  Starred:
    "Uh oh! Looks like there are no sheets marked ‘<b>Starred</b>’ in your Google Drive.",
};
const WARNING_MESSAGE =
  "We've fetched data from the above data range. You can control this range. Please change the column names and row numbers from which you want us to fetch the data.";

export {
  DOC_OWNER,
  EMPTY_SHEET_MSG,
  EXTERNAL_USER,
  ACCOUNT_OWNER,
  WARNING_MESSAGE,
};
